module.exports = __webpack_public_path__ + "img/证券时报@2x.911f311.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/证券时报@2x.png
// module id = ItFy
// module chunks = 3